module.exports = __webpack_public_path__ + "static/media/39.55635048.png";